/**
 * Product cards in blog articles: a paragraph holding only links to product
 * pages (one per line or comma-separated) renders as product cards. Writers
 * add them in the Shopify editor as a normal link on its own line.
 */
export type ArticleSegment =
  | { type: "html"; html: string }
  | { type: "products"; html: string; handles: Array<string> };

const PRODUCT_PARAGRAPH =
  /<p>\s*((?:<a\s[^>]*href="[^"]*\/products?\/[a-z0-9-]+[^"]*"[^>]*>[\s\S]*?<\/a>\s*(?:,|<br\s*\/?>)?\s*)+)<\/p>/gi;
const PRODUCT_HANDLE = /href="[^"]*\/products?\/([a-z0-9-]+)/gi;

function handlesIn(html: string) {
  return [...new Set([...html.matchAll(PRODUCT_HANDLE)].map((m) => m[1]))];
}

export function splitArticleBody(html: string): Array<ArticleSegment> {
  const segments: Array<ArticleSegment> = [];
  let last = 0;
  for (const match of html.matchAll(PRODUCT_PARAGRAPH)) {
    if (match.index > last) {
      segments.push({ type: "html", html: html.slice(last, match.index) });
    }
    segments.push({
      type: "products",
      html: match[0],
      handles: handlesIn(match[1]),
    });
    last = match.index + match[0].length;
  }
  if (last < html.length)
    segments.push({ type: "html", html: html.slice(last) });
  return segments;
}

/** Every product handle the article shows as a card, in order. */
export function articleProductHandles(html: string) {
  return [
    ...new Set(
      splitArticleBody(html).flatMap((s) =>
        s.type === "products" ? s.handles : [],
      ),
    ),
  ];
}
